import styled from 'styled-components';
import { buildStyledComponent } from 'decisiv-ui-utils';

/* istanbul ignore next */
const styles = `
  display: flex;
  flex-direction: column;
`;

export default buildStyledComponent(
  'InputWrapper',
  styled.div,
  styles,
);



// WEBPACK FOOTER //
// ./compositions/ServiceProviderSelectionStep/InputWrapper.js